import React from 'react';
import { doubleSideTHT as tooltip } from 'pu-data/Tooltips';
import RadioDualComponent from './RadioDualComponent';

const DoubleSideTHT = (props) => {
  const name = 'double_sided_tht';
  const onChange = (e) => props.onChangeParameter(name, e.target.value);
  return (
    <RadioDualComponent
      name={name}
      label="Double-sided THT"
      tooltip={props.tooltip}
      onChange={onChange}
      parameters={props.parameters}
      className={props.className} />
  );
};

DoubleSideTHT.defaultProps = {
  tooltip,
  className: 'double-side-smt',
};

export default DoubleSideTHT;
